/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import computedFindBy from 'cio/utils/computed-find-by';

const STATE_INFOS = [
  {
    state: 'Queued',
    classNames: '',
  },
  {
    state: 'InProgress',
    label: 'In Progress',
    classNames: 'is-warning',
  },
  {
    state: 'Failure',
    classNames: 'is-error',
  },
  {
    state: 'Success',
    classNames: 'is-success',
  },
  {
    state: 'Retrying',
    classNames: 'is-secondary',
  },
  {
    state: 'Canceled',
    label: 'Canceled',
    classNames: 'is-secondary',
  },
];

@tagName('')
export default class BackfillStateTag extends Component {
  // Public API
  backfillState = null;

  stateInfos = STATE_INFOS;

  @computedFindBy('stateInfos', 'state', 'backfillState') stateInfo;
}
